var exports = {
  "E": "Blankslate__D3qaq7",
  "m": "Octicon__kQ_i6I",
};

module.exports = exports;
